mutation TestMailerConfig($id: ID!) {
  testMailerConfig(id: $id)
}
